import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

/**
 * Shared App Insights React plugin singleton.
 *
 * App.tsx registers this instance as an extension of ApplicationInsights and
 * exposes it through AppInsightsContext. Keeping the instance here lets
 * non-React utilities (e.g. utilities/publishBridgeEvent) send telemetry
 * without importing App.tsx, which would create a circular import.
 *
 * Calls made before App.tsx calls loadAppInsights() are no-ops.
 */
const reactPlugin = new ReactPlugin();

export default reactPlugin;
